import {ChartTypeEnum} from  "@/components/explorer/visualizations/ChartTypeEnum.js"
import * as Accessibility from "@/components/accessibility/accessibility.js";
import markdownit from 'markdown-it'
import { event } from 'vue-gtag'
import  * as AppliedValues from "@/components/explorer/visualizations/AppliedValues.js";
import _Highcharts from "highcharts";

const version = __APP_VERSION__

const md = markdownit()

class ChartSettings {
  constructor(xAxisDim, seriesDim, type, toggleStack, toggleHorizontalBar) {
	this.type = type
    this.xAxisDim = xAxisDim;
    this.seriesDim = seriesDim;
    this.toggleStack = toggleStack;
    this.toggleHorizontalBar = toggleHorizontalBar
  }
}

async function defineChartProps(type, indicatorObj, chartSettings, { onMoreClick }) {
	let yValue = indicatorObj.valuesLabel;
	let allFilters = getCategoryFilters(indicatorObj)

	chartSettings.request =  AppliedValues.buildRequest(indicatorObj, chartSettings, yValue, allFilters);
	//console.log('chartSettings',chartSettings)
	//AppliedValues.applyRequestFilters(indicatorObj, type, chartSettings.request)
	chartSettings.request.categories.forEach(cat => {
		if(cat.filters.length == 0) {
			throw new Error("No records found");
		}
	})
	if(import.meta.env.VITE_APP_DEBUG)
		console.log('chartSettings', chartSettings)

	let results = await fetchData(chartSettings.request)
	//console.log('response Bar chart',results)
	if(Object.keys(results).length == 0 || Object.keys(Object.values(results)[0]).length == 0) {
	 	throw new Error("No records found");
	} else {
		let noData = true;
		const isEmpty = (obj) => Object.keys(obj).length === 0;
		Object.entries(results).forEach(([key, item]) => {
			const truthyOnly = Object.fromEntries(
				Object.entries(item).filter(([_, value]) => !!value)
			);
			if(!isEmpty(truthyOnly)) {
				noData = false;
			}
		});
		if(noData) {
			throw new Error("No records found");
		}
	}

	let props = buildChartJson(type, indicatorObj, yValue, chartSettings, results, { onMoreClick })
	//console.log('chartProps',props)
	return props;
}

async function fetchData(request) {
	//console.log(indicatorObj)
	const apiUrl = import.meta.env.VITE_API_URL;
	let reqDims = request.xAxis + ',';
	let reqFilters = '';
	request.categories.forEach((cat) => {
		if(cat.selected) {
			reqDims += cat.categoryName;
		}
		reqFilters += cat.categoryName + ': ' + cat.filters.join() + '|';
	})
	event('filter_dataset', { 'indicator' : request.datasetName, 'dimensions': reqDims, 'filter' : reqFilters.slice(0,100).slice(0,-1) })

	let url = apiUrl + '/indicators/api/chartdata'
	let response = await fetch(url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'x-api-version': version
		},
			body: JSON.stringify(request)
		}
	)
	if (!response.ok) {
		throw new Error(`HTTP status: ${response.status}`);
	}
	return await response.json()
}

const buildChartJson = (type, indicatorObj, yValue, chartSettings, result, { onMoreClick }) => {
	//const usdFormatter = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2});
	const pctFormatter = new Intl.NumberFormat('en-US', {minimumFractionDigits: indicatorObj.decimalPrecision,maximumFractionDigits: 2});
	const floatFormatter = new Intl.NumberFormat('en-US', {minimumFractionDigits: indicatorObj.decimalPrecision, maximumFractionDigits: 100});
	const numFormatter = new Intl.NumberFormat('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 100});
	const valuesUnit = indicatorObj.valuesUnit; // == "Currency", "Percent", "Number"
	//TODO: Enable new formatter logic if Float valuesUnit implemented
	let formatter = valuesUnit == "Currency"?numFormatter:valuesUnit == "Percent"?pctFormatter:valuesUnit=="Float"?floatFormatter:numFormatter
	//let formatter = valuesUnit == "Currency"?numFormatter:valuesUnit == "Percent"?pctFormatter:numFormatter
	const valuesMultiplier = (indicatorObj.chartMultiplier ? parseInt(indicatorObj.chartMultiplier) : 1);
	//const valuesRoundingUnit = (indicatorObj.roundingUnit && indicatorObj.roundingUnit.length > 0 ? '(' + indicatorObj.roundingUnit.replace(/[$%]/g, "") + ')' : null);

	const valuesRoundingUnit = (indicatorObj.roundingUnit && indicatorObj.roundingUnit.length > 0 ? '(' + indicatorObj.roundingUnit + ')' : null);
	const axisLabel = indicatorObj.roundingUnit

	const classNameBase = Accessibility.readUserPreference('patternfill') === 'true' ? 'indicators-chart-series-pattern-' : 'indicators-chart-series-';
	const modulo = Accessibility.readUserPreference('colorblind') === 'achromatopsia' ? 10 : 88;

	let yAxisTitle = null
	let ctype = type != null?type:'bar'
   	let chartprops = {
		lang: {
			locale: 'en-US'
		},
		chart: {
			type: ctype,
			styledMode: true,
			// spacingTop: 20,
			// spacingLeft: 10,
			// spacingRight: 10,
			// Explicitly tell the width and height of a chart
			/*height: 560,*/
			height: 0,
			width: null,
			events: {
				render() {
					//add Full Source button link to footer to support mobile format
					const links = this.container.querySelectorAll('.footnote-more');
					if(links != null) {
						links.forEach(link => {
							if (link && !link.dataset.bound) {
								link.dataset.bound = 'true';

								link.addEventListener('click', (e) => {
									e.preventDefault();
									//console.log('clicked', e)
									onMoreClick(e)
								});
							}
						})
					}

					//reformat title/subtitle to support wrapped labels in mobile layout
					const chart = this;
					if (!chart.title || !chart.subtitle) {
						return;
					}
					const titleBBox = chart.title.getBBox();
					if(titleBBox.height < 30) {
						chart.subtitle.attr({
							y: chart.title.alignAttr.y + titleBBox.height 
						});
					} else {
						chart.title.attr({
							y: titleBBox.height - 50
						});						
						chart.subtitle.attr({
							y: titleBBox.height
						});
					}

					const caption = this.caption;
					if (caption && caption.css) {
						caption.css({
							width: (this.chartWidth - 40) + 'px'
						});
					}			
				}
			}
		},
		plotOptions: {
		},
		credits: {
			enabled: false
		},
		title: {
			text: ''
		},
    	subtitle: {
			text: ''
		},		
		legend: {
			//align: "left",
			events: {
				itemClick: function (e) {
					e.preventDefault(); 
					return false;	
				}
			},
			maxHeight: 150,
			title: {
				text: ''
			}
		},
/* 		plotOptions: {
			series: {
				pointWidth: 40 // Sets the width of bars in a bar chart to 20 pixels
			}
		}, */
		xAxis: {
			title:{
				text:''
			},
			labels: {
				useHTML: false,
				formatter: function() {
					return this.value.replace(';', ';</br/>');
				}
			},
			categories: []
		},
		yAxis: {
			title: {
				text: axisLabel
			},
			labels: {
				allowOverlap: false,
				overflow: false,
				formatter: function () {
					if(type==='bar' && this.isLast) {
						try {
							const plotRightEdge = this.chart.plotBox.x + this.chart.plotBox.width
							const labels = this.axis.labelGroup.element.querySelectorAll('text')
							const labelBox = labels[labels.length - 1].getBBox();
							const labelEndX = labelBox.x + labelBox.width;
							if(labelEndX - plotRightEdge < 40  ){
								/* the last label is overflowing past the edge of the plot, remove it */
								return null							
							}
						} catch(e) {
							/*dont worry about it*/
						}
					}
					if(this.value == 0) {
						return this.value
					} else {
						return formatter.format(this.value) // _Highcharts.numberFormat(this.value, 0)
					}
				}
			}
		},
		series: [],
		responsive: {
			rules: [{
				condition: {
					maxWidth: 600
				},
				chartOptions: {
					legend: {
						enabled: false
					}
				}
			}]
		},		
		exporting: {
			buttons: {
			 	contextButton: {
			 		enabled: false // hides the built-in button
			 	}
			},
			local: true,
			libURL: 'highcharts-libs/',
			fallbackToExportServer: false, // use offline export only
			chartOptions: {
				chart: {
					type: ctype,
					style: {
						//prevents warning on fetching font files that are not needed
						fontFamily: 'Roboto,sans-serif'
					},
					spacingBottom: 24
				},
				title: {
					style: {
						fontSize: '20px', //'var(--font-size-H6, 1.25rem)',
						color: '#2C2C2C', //'var(--text-Header)'
						fontWeight: 700,
					}
				},
				legend: {
					itemStyle: {
						fontSize: '12px', //'var(--font-size-Base, 1rem);',
						color: '#2C2C2C'  //'var(--text-Primary, #2C2C2C);',
					},
					title: {
						style: {
							fontSize: '16px', //' var(--font-size-Base, 1rem);',
							color: '#2C2C2C'   //'var(--text-Primary, #2C2C2C);',
						}
					}
				},
				xAxis: {
					labels: {
						style: {
							fontSize: '12px' // Override x-axis label font size for export
						},
						useHTML: false,
						formatter: function() {
							return this.value.replace(';', ';</br/>');
						}
					},
					title: {
						style: {
							color: '#171717', // 'var(--text-Header,#171717)',
							fontSize: '16px', //'var(--font-size-Base, 1rem)',
						}
					}
				},
				yAxis: {
					title: {
						style: {
							color: '#171717', // 'var(--text-Header,#171717)',
							fontFamily:  '"Roboto",sans-serif', //'var(--font-family-Title, Roboto)',
							fontSize: '16px', //'var(--font-size-Base, 1rem)',
							fontStyle: 'normal',
							fontWeight: '500'
						}
					},
					labels: {
						itemStyle: {
							fontSize: '16px' // 'var(--font-size-Base, 16px);' // Set the font size here
						}
					}
				},

			}
		},
		tooltip: {
			formatter: function () {

				let title = yValue;
				if(valuesRoundingUnit) {
					title += ' ' + valuesRoundingUnit;
				}
				let header =`<div class="header"><span class="title">${title}</span>`;
				header += 
				`	<div class="label">${chartSettings.xAxisDim.columnName}:${this.category}</div>
					<div class="label">${chartSettings.seriesDim.columnName}:</div>
				</div>`;

				let value = formatter.format(this.y)
				let className = 'tt-circle ' + this.series.userOptions.className;
				const icon = `<span class="${className}"><svg width="10px" height="10px"><circle r="5px" cx="5px" cy="5px"/></svg></span>`;
				const body = `<span class="explorer-tool-tip-list">${icon}&nbsp;${this.series.name}: <b>${value}</b></span>`
				return `<div class="explorer-tool-tip">${header}${body}</div>`; 
			},
			useHTML: true,
			style: {
				zIndex: 9999   // force tooltip above legend
			},
			shared: false // or true depending on default or user config
		}
  	}

	if( chartSettings.toggleStack) {
		chartprops.tooltip = {
			shared: true, // <--- Key setting
			useHTML: true,
			style: {
				zIndex: 9999   // force tooltip above legend
			},
			outside: true,
			positioner: function (labelWidth) {
				let tooltipX = this.chart.hoverPoint.point.barX + (this.chart.hoverPoint.pointWidth * 3);
				const tooltipTop = this.chart.plotTop + (this.chart.plotHeight/2) - (this.label.height / 2);
				if(type == 'bar') {
					tooltipX = this.chart.plotWidth - this.chart.hoverPoint.shapeArgs.y - (labelWidth / 2); //this.chart.plotLeft +
				}
				tooltipX = Math.min(tooltipX,this.chart.plotWidth-labelWidth);
				return { x: Math.max(tooltipX,0), y: tooltipTop};
			},
			formatter: function () {
			
				let title = yValue;
				if(valuesRoundingUnit) {
					title += ' ' + valuesRoundingUnit;
				}
				let header =`<div class="header"><span class="title">${title}</span>`;
				header += 
				`	<div class="label">${chartSettings.xAxisDim.columnName}:${this.category}</div>
					<div class="label">${chartSettings.seriesDim.columnName}:</div>
				</div>`;

				let i = 0;
				let rows = this.points.map(point => {
					let color = '#000000';
					//const seriesClass = document.querySelector('.'+ classNameBase + point.series.colorIndex);
					const seriesClass = document.querySelector('.'+ classNameBase + i % modulo);
					i++;				

					if(seriesClass) {
						color = getComputedStyle(seriesClass).stroke;
					}
					let value = formatter.format(point.y)

					let icon = createMarker(point, color, 12)
					return `<div>${icon}&nbsp;${point.series.name}:&nbsp;<b>${value}</b></div>`;					
				});
				//return '<div class="explorer-tool-tip">' + header + rows.join('') + '</div>';
				const n = Math.ceil(this.points.length/32); //width: '+n*16+'rem;							
				return '<div class="explorer-tool-tip">' + header + '<ul style="list-style-type:none; padding:0; margin:0; columns: ' + n + ' auto; overflow: hidden;">' + rows.join('') + '</ul></div>';



				function createMarker(point, color, size) {
					const symbol = point.series.symbol||'circle'; // point.series.options.marker.symbol;
					switch (symbol) {

						case 'circle':
							return `
								<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}">
									<circle cx="6" cy="6" r="4"
										fill="${color}" stroke="${color}" />
								</svg>`;

						case 'square':
							return `
								<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}">
									<rect x="2" y="2"
										width="8"
										height="8"
										fill="${color}" stroke="${color}" />
								</svg>`;

						case 'diamond': 
							return `
								<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}">
								<path
									d="M6 1 L11 6 L6 11 L1 6 Z"
									fill="${color}" stroke="${color}"  />
								</svg>`;

						case 'triangle':
							return `
								<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}">
									<path
										d="M6 1 L11 11 L1 11 Z"
										fill="${color}" stroke="${color}" />
								</svg>`;
						case 'triangle-down':
							return `
								<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}">
									<path
										d="M1 1 L11 1 L6 11 Z"
										fill="${color}" stroke="${color}" />
								</svg>`;				
					}
				}

			}

		}
	}


	//chartprops.title.text = indicatorObj.indicatorName;
	//chartprops.yAxis.title.text = yValue;
	//chartprops.title.text = indicatorObj.valuesLabel 
	let title = `${indicatorObj.valuesLabel} by ${chartSettings.xAxisDim.columnName} and ${chartSettings.seriesDim.columnName}`
	let year = indicatorObj.columns.items.find(x => x.columnName == 'Year')
	if(year) {
		const minYear = Math.min(...year.appliedValues.filter(x => x.selected).map(item => Number(item.name)));
		const maxYear = Math.max(...year.appliedValues.filter(x => x.selected).map(item => Number(item.name)));
		if(minYear == maxYear)
			title += ": " + minYear
		else
			title += ": " + minYear + "\u2013" + maxYear
	}
	chartprops.title.text = title

	let filters = ''
	let cols = 	indicatorObj.columns.items.filter(c => {
		if(c.valueFlag == 0 && c.categoryLabelFlag == 1 && c.columnName != 'Year'
			&& c.columnName != chartSettings.xAxisDim.columnName
			&& c.columnName != chartSettings.seriesDim.columnName
			&& c.columnName != chartSettings.seriesDim.parentColumnName
			&& c.columnName != chartSettings.seriesDim.childColumnName
			&& c.childColumnName == null) {
				return c
			}
		})
	cols.forEach((c, n) => {
		let selected = "<span class='section-break'>" + c.columnName + ": "
		if(c.appliedValues && c.appliedValues.length > 0) {
			let all = c.totalLabel 
			let values = c.appliedValues.filter(x => x.selected && x.name != all)
			if(values.length > 0) {
				values.forEach((v, i) => selected += v.name + (i < values.length-1?', ': n < cols.length -1?'; ':''))
				filters += selected + "</span>"
			}
		}
	})
	chartprops.subtitle.text = filters

	/*if(valuesRoundingUnit) {
		chartprops.title.text += ' ' + valuesRoundingUnit;
	}*/
	chartprops.xAxis.title.text  = chartSettings.xAxisDim.columnName;
	chartprops.legend.title.text = chartSettings.seriesDim.columnName;

	if(chartSettings != null && chartSettings.toggleStack) {
		if(type == 'column') {
			chartprops.plotOptions.column = {stacking: "normal"} //"percent";
			chartprops.plotOptions.series = {stacking: "normal"} //"percent";
		} else if(type == 'bar') {
			chartprops.plotOptions.bar = {stacking: "normal"}  //"percent";
			chartprops.plotOptions.series = {stacking: "normal"}  //"percent";
		}
		//format bar labels -  IF REQUIREMENTS CHANGE TO SHOW LABELS, UNCOMMENT THIS SECTION
/* 		chartprops.plotOptions.series.dataLabels = {
			enabled: true,
			// formatter: function () {
			// 	return Math.round(this.percentage) + '%'; // Display percentage on bars
			// },
			style: {
				// CSS properties to style the data label text
				color: '#000', // Example: set text color to red
				fontSize: '16px', // Example: set font size to 12px
				fontWeight: 'bold', // Example: set font weight to bold
				// Add more CSS properties as needed
				textOutline: 'none'
			}
		} */
	} else {
		if(type == 'column') {
			chartprops.plotOptions.column = {stacking: null};
			chartprops.plotOptions.series = {stacking: null};
		} else if(type == 'bar') {
			chartprops.plotOptions.bar = {stacking: null};
			chartprops.plotOptions.series = {stacking: null};
		}

		//show labels for data bars -  IF REQUIREMENTS CHANGE TO SHOW LABELS, UNCOMMENT THIS SECTION
/* 		chartprops.plotOptions.series.dataLabels = {
			enabled: true,
			// formatter: function () {
			// 	return Math.round(this.percentage) + '%'; // Display percentage on bars
			// },
			style: {
				// CSS properties to style the data label text
				color: '#000', // Example: set text color to red
				fontSize: '12px', // Example: set font size to 12px
				fontWeight: 'normal', // Example: set font weight to bold
				// Add more CSS properties as needed
				textOutline: 'none'
			}
		} */

	}
	//need to exclude "All" values from the X Axis labels
	//let xAxisMarks = Object.values(chartSettings.xAxisDim.appliedValues).filter(i => i.selected)
	//chartprops.xAxis.categories = xAxisMarks.map(i => i.name)
	let availableData = Object.entries(result);
	let xAxisMarks = Object.keys(availableData[0][1])
	chartprops.xAxis.categories = xAxisMarks
 	//Build series array which contains all data points for a line
	//let dimAllValue = chartSettings.seriesDim.totalLabel

	//Build series array which contains all data point for a bar
	let catName = chartSettings.seriesDim.columnName
	for(let b = 0; b < availableData.length; b++) {
		let xSeriesValue = {}
		let dataPoints = []

		let catValue = availableData[b][0]
		xSeriesValue.name = catValue
		xSeriesValue.visible = true

		let values = availableData[b][1]
 		for (let v in values) {
			//dataPoints.push(parseFloat(values[v]) * valuesMultiplier)
			const val = !isNaN(values[v]) ? parseFloat(values[v]) : Number(values[v].replaceAll(",", ""));
			dataPoints.push(val)
		}

		// xSeriesValue.marker = {
		// 	symbol: 'triangle'
		// },   
		xSeriesValue.data = dataPoints
		xSeriesValue.className = classNameBase + b % modulo;
		xSeriesValue.colorIndex = b % modulo;
		xSeriesValue.maxPointWidth = 75
		if(chartSettings.toggleStack)
			xSeriesValue.stack = catName;
		else
 			xSeriesValue.stack = null;
		chartprops.series.push(xSeriesValue)
	}
	if(chartSettings.seriesDim.filters) {
		delete chartSettings.seriesDim.filters
	}
	const validateSelected = chartprops.series.find(x => x.visible)
	if(validateSelected == undefined)
		throw new Error("No records found");

	chartprops.colorCount = availableData.length % 88;

	const abbr = indicatorObj.abbreviations ? indicatorObj.abbreviations.join('; ') + '.' : '';
	const src = md.renderInline(indicatorObj.source);
	//srcHtml is used in the footer mobile modal
	chartSettings.srcHtml = src
	chartSettings.keyHtml = indicatorObj.abbreviations ? indicatorObj.abbreviations.join('.<br />') + '.' : '';

	let footerNotes = `<div class="explorer-footnote-wrapper">`
	if(indicatorObj.abbreviations && indicatorObj.abbreviations.length > 0) {
		footerNotes += `	<span class="explorer-footnote"><span class="title">Key:</span> ${abbr} </span>`
		footerNotes += `	<button class="btn-tertiary footnote-more" data-value='abbreviations'>Full Key</button><br />`
	}
	footerNotes += `	<button class="btn-tertiary explorer-footnote-link" data-value='source'>See full data notes</button><br/>`
	footerNotes += `	<span class="explorer-footnote"><span class="title">Source(s):</span> ${src} </span>`
	footerNotes += `	<button class="btn-tertiary footnote-more" data-value='source'>Full Source</button>`
	footerNotes += `</div>`

  	let footerNotesExp = `<div class="explorer-footnote-wrapper">`
	if(indicatorObj.abbreviations && indicatorObj.abbreviations.length > 0) {
		footerNotesExp += `<span class="explorer-footnote"><span class="title">Key:</span> ${abbr} </span><br/>`
	}
	footerNotesExp += `<span class="explorer-footnote"><span class="title">Source(s):</span> ${src} </span></div>`

	let footer = {}
	footer.align = "left"
	footer.verticalAlign = "bottom"
	footer.useHTML = true
	footer.text = footerNotes
	chartprops.caption = footer;

	let footerExp = {}
	footerExp.align = "left"
	footerExp.verticalAlign = "bottom"
	footerExp.useHTML = false
	footerExp.text = footerNotesExp
	chartprops.exporting.chartOptions.caption = footerExp;

	return chartprops
}

async function refreshBarChart(type, chart, indicatorObj, chartSettings, dim, { onMoreClick }) {
	if(chart != null) { 
		let props = await defineChartProps(type, indicatorObj, chartSettings, { onMoreClick })
		//console.log('chartProps',props)
		return props
	}
}

function getCategoryFilters(indicator) {
	let columns = indicator.columns.items.filter(col => {
		if(col.categoryLabelFlag  || col.xAxisFlag) {
			//Parent in hierarchies should not be a category when it does not have subTotals - this would cause API error
			//if(col.childColumnName == null || col.includeParentFlag)
				return col;
		}
	})
	return columns
}

//Set Xaxis to first dim, if it is a year limit Xaxus to the earliest year. For all other dims, show all values
function getBarChartSettings(indicator, type, userInputStatus) {
	if(import.meta.env.VITE_APP_DEBUG) {
		console.log('getBarChartSettings')
		console.log('userInputStatus.year',userInputStatus.year)
		
	}

	AppliedValues.setupAppliedValues(indicator)
	let xAxisDim = indicator.columns.items.find(col => {
		if(col.categoryLabelFlag && col.xAxisFlag && col.columnName == 'Year') {
			return col
		}
	})
	
	if(xAxisDim != null && !userInputStatus.year && xAxisDim.defaultValues.length < 1) {
		xAxisDim.appliedValues.forEach((s, i)=> {
			if(i < xAxisDim.appliedValues.length - 3)
				s.selected = false;
			else
				s.selected = true
		})
	}

	//If no Year dim, use first category as X Axis
	if(xAxisDim == null) {
		xAxisDim = indicator.columns.items.find(col => {
			if(col.categoryLabelFlag && col.xAxisFlag) {
				//seleect first item as default bar value
				//col.appliedValues[0].selected = true
				return col;
			}
		})
		if(xAxisDim == null) {
			throw new Error("Indicator categories are not valid for use on the X Axis")
		}
	}

	//default selected category to first valid category
	let seriesDim = indicator.columns.items.find(col => {
		if(col.categoryLabelFlag && col.columnName !== xAxisDim.columnName) {
			//Parent in hierarchies should not be a category when it does not have subTotals - this would cause API error
			if(col.childColumnName == null) {
				return col;
			}
		}
	})
	if(seriesDim == null) {
		throw new Error("Indicator categories are not valid for use as a series")
	}

	const toggleHorizontalBar = type == "bar"?true:false
	//const toggleStack = indicator.defaultApiChartType == ChartTypeEnum.BARHS.apiName||ChartTypeEnum.BARS.apiName?true:false
	const toggleStack = [ChartTypeEnum.BARHS.apiName,ChartTypeEnum.BARS.apiName].includes(indicator.defaultApiChartType)?true:false
	return new ChartSettings(xAxisDim, seriesDim, type, toggleStack, toggleHorizontalBar)
}

function updateBarChartSettings(settings, indicator, type, userInputStatus) {
	if(import.meta.env.VITE_APP_DEBUG) {
		console.log('updateBarChartSettings')
		console.log('userInputStatus.year',userInputStatus.year)
	}
	//If no xAxisDim set it to Year, if no Year, set xaxis to first dim.  Default only the first value for xAxis to selected
	if(settings.xAxisDim == null) {
		settings.xAxisDim = indicator.columns.items.find(col => {
			if(col.categoryLabelFlag && col.xAxisFlag
				&& col.columnName == "Year") {
				return col;
			}
		})
		if(settings.xAxisDim == null) {
			//If no Year dim, use first category as X Axis
			settings.xAxisDim = indicator.columns.items.find(col => {
				if(col.categoryLabelFlag && col.xAxisFlag) {
					return col;
				}
			})
			if(settings.xAxisDim == null) {
				throw new Error("Indicator categories are not valid for use on the X Axis")
			}
		}
		/*if(settings.xAxisDim != null) {
			settings.xAxisDim.appliedValues.forEach((s, i)=> {
				if(i < settings.xAxisDim.appliedValues.length - 3)
					s.selected = false;
				else
					s.selected = true
			})
		}*/
	} else if(settings.xAxisDim != 'Year' && settings.type != type) {
		//default xaxis to year if it exists
		/*const tmpXaxis = indicator.columns.items.find(col => {
			if(col.categoryLabelFlag && col.xAxisFlag
				&& col.columnName == "Year") {
				return col;
			}
		})
		if(tmpXaxis != null && !userInputStatus.year) {
			tmpXaxis.appliedValues.forEach((s, i)=> {
				if(i < tmpXaxis.appliedValues.length - 3)
					s.selected = false;
				else
					s.selected = true
			})
			settings.xAxisDim = tmpXaxis
		}*/
	}
	settings.type = type

	if(settings.seriesDim == null || settings.seriesDim.columnName == settings.xAxisDim.columnName) {
		settings.seriesDim = indicator.columns.items.find(col => {
			if(col.categoryLabelFlag && col.columnName != settings.xAxisDim.columnName) {
				//Parent in hierarchies should not be a category when it does not have subTotals - this would cause API error
				if(col.childColumnName == null) {
					return col;
				}
			}
		})
	}
	//If seriesDim is a geography column use defaultValues if user has not input
	if(settings.seriesDim.geoLabelFlag && !userInputStatus.geo) {
		const defaultValuesTrimmed = settings.seriesDim.defaultValues.map(item => 
			typeof item === 'string' ? item.trim() : item
		);
		if(defaultValuesTrimmed.length){
			settings.seriesDim.appliedValues.forEach(x => {
				if(defaultValuesTrimmed.includes(x.name)){
					x.selected = true
				}else {
					x.selected = false
				}
			})
		}
	}

	if(settings.seriesDim == null) {
		throw new Error("Indicator categories are not valid for use as a series")
	}
	settings.toggleHorizontalBar = type == ChartTypeEnum.BARH.chartName?true:false
	if(settings.toggleStack == null) settings.toggleStack = false;

	return settings;
}

//Method called when chart is being rebuilt from URL parameters
function rebuildBarChartSettings(indicator, type, objReq) {
	if(import.meta.env.VITE_APP_DEBUG)
		console.log('rebuildBarChartSettings')
	const req = objReq.request
	let xAxisDim = indicator.columns.items.find(col => col.columnName == req.xAxis)
	let reqSeries = req.categories.find(cat => cat.selected)
	let seriesDim = indicator.columns.items.find(col => col.columnName == reqSeries.categoryName)

	AppliedValues.setupAppliedValues(indicator)
	AppliedValues.applyRequestFilters(indicator, type, objReq.request)
	const toggleHorizontalBar = type == "column"?true:false
	//const toggleStack = indicator.defaultApiChartType == ChartTypeEnum.BARHS.apiName||ChartTypeEnum.BARS.apiName?true:false
	const toggleStack = [ChartTypeEnum.BARHS.apiName,ChartTypeEnum.BARS.apiName].includes(indicator.defaultApiChartType)?true:false
	seriesDim.filters = reqSeries.filters
	const chartSettings = new ChartSettings(xAxisDim, seriesDim, type, toggleStack, toggleHorizontalBar)
	chartSettings.toggleHorizontalBar = objReq.toggleHorizontalBar?objReq.toggleHorizontalBar:false
	chartSettings.toggleStack = objReq.toggleStack?objReq.toggleStack:false;

	return chartSettings
}

function validateRequestProps(obj, indicator) {
	return AppliedValues.validateRequestValues(obj, indicator, ChartTypeEnum.BAR.chartName)
}
export {defineChartProps, refreshBarChart, getBarChartSettings, updateBarChartSettings, rebuildBarChartSettings, validateRequestProps, ChartSettings}
